import { MessageCircle } from 'lucide-react';
import { useEffect, useState } from 'react';

import { whatsappUrl, whatsappUrlEn } from '@/lib/whatsapp';

type PublicFloatingWhatsAppProps = {
  locale: 'zh' | 'en';
};

export function PublicFloatingWhatsApp({ locale }: PublicFloatingWhatsAppProps) {
  const [contactVisible, setContactVisible] = useState(false);
  const isZh = locale === 'zh';

  useEffect(() => {
    const contact = document.querySelector('#contact');
    if (!contact) return;

    const observer = new IntersectionObserver(
      ([entry]) => setContactVisible(entry.isIntersecting),
      { threshold: 0.05 },
    );
    observer.observe(contact);
    return () => observer.disconnect();
  }, []);

  return (
    <a
      href={isZh ? whatsappUrl : whatsappUrlEn}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={isZh ? 'WhatsApp 查詢' : 'WhatsApp enquiry'}
      aria-hidden={contactVisible}
      tabIndex={contactVisible ? -1 : undefined}
      className={`public-floating-whatsapp fixed right-4 z-50 inline-flex size-12 items-center justify-center rounded-full bg-doq-green text-sm font-semibold text-white shadow-[0_16px_40px_rgba(6,61,54,0.32)] transition duration-200 hover:-translate-y-1 hover:bg-[#0b4a42] focus:outline-none focus:ring-2 focus:ring-doq-copper focus:ring-offset-2 focus:ring-offset-doq-surface sm:right-5 sm:h-14 sm:w-auto sm:gap-3 sm:px-5 ${
        contactVisible ? 'pointer-events-none translate-y-2 opacity-0' : ''
      }`}
    >
      <MessageCircle className="size-5" strokeWidth={2} />
      <span className="hidden sm:inline">{isZh ? 'WhatsApp 查詢' : 'WhatsApp enquiry'}</span>
    </a>
  );
}
